import { useCallback, useEffect, useState } from 'react';

import { usePlayer } from '../../player/hooks/usePlayer';

import { usePlayerEvent } from './usePlayerEvent';

export const useJWPlayer = () => {
  const player = usePlayer();
  const [jwPlayer, setJWPlayer] = useState(() => player?.getJWPlayer() || null);

  const handleReady = useCallback(() => {
    setJWPlayer(player?.getJWPlayer() ?? null);
  }, [player]);

  useEffect(handleReady, [handleReady]);

  usePlayerEvent('ready', handleReady);

  return jwPlayer;
};
